var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoiceFemaleActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 22.5c0 6.929-3.203 13.11-8.21 17.144-2.181.97-4.255 1.075-6.467.925-.808-.055-1.622-.142-2.468-.233-.333-.036-.67-.072-1.015-.107-1.212-.123-2.486-.229-3.84-.229-1.63 0-3.216.1-4.72.196-.946.06-1.859.117-2.73.147-2.267.077-4.353-.028-6.357-.714C3.695 35.596.5 29.422.5 22.5c0-12.15 9.85-22 22-22s22 9.85 22 22z",
    fill: "#E5E7EA",
    stroke: "#B8EF36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.516 35.385l-2.183-1.22a9.011 9.011 0 01-3.964-4.505 10.75 10.75 0 001.156-1.578 28.421 28.421 0 004.484-1.429c-1.208-1.473-1.627-2.423-1.037-6.851.665-6.335-3.774-9.643-8.472-9.78-4.699.137-9.138 3.445-8.472 9.78.59 4.428.17 5.378-1.037 6.852 1.51.62 3.004 1.091 4.483 1.428.346.57.734 1.104 1.157 1.578a9.014 9.014 0 01-3.965 4.506l-2.182 1.219a9.01 9.01 0 00-4.033 4.684 22.4 22.4 0 0014.049 4.93 22.399 22.399 0 0014.049-4.931 9.011 9.011 0 00-4.033-4.683z",
    fill: "#2B8982"
  })));
}
export default SvgVoiceFemaleActive;